import { USER_ROLES } from './constants'

export const isValidEmail = (email: string) => email.length > 2 && email.includes('@')

export const isValidPassword = (password: string) => password.match("^(?=.*\\d{1})(?=.*[a-z]{1})(?=.*[A-Z]{1})(?=.*[!@#$%^&*{|}?~_=+.-]{1})(?=.*[^a-zA-Z0-9])(?!.*\\s).{8,24}$")

export const isAdmin = (user: User) => user.authorities && user.authorities[0] && user.authorities[0].authority === `ROLE_${USER_ROLES.ADMIN}`
